import { useMemo } from 'react';
import { useVendor } from '@context/VendorContext';

import config from '../config';
import { useApp } from '../context/AppContext';
import {usePermissions} from "@hooks/usePermissions";

export default function useVendorOrganizationAccess() {
  const { user, userIsFetched } = useApp();
  const { isAdmin} = usePermissions();
  const { vendor, isFetched } = useVendor();

  return useMemo(() => {
    return {
      isLoaded: isFetched && userIsFetched,
      hasAccess:
        (isFetched &&
          vendor.features?.includes(config.features.organizations)) ||
        (userIsFetched && isAdmin),
    };
  }, [user, userIsFetched, vendor.features, isFetched]);
}
